import { Factors } from '@commutifi-fe/constants'
import { useComponentIntl } from '../../locales'

export function MetricLabel({ metricType }: { metricType: `${Factors}` }) {
  const intl = useComponentIntl('Metrics')
  return intl.formatMessage({ id: `label.${metricType}` })
}

export default MetricLabel
